import API from './API'
const route = 'manager/'

var Manager = (function () {
  function manager() {}
  manager.prototype.getDetail = function (id) {
    return API.get(`${route}${id}`)
  }

  manager.prototype.create = function (data) {
    return API.post(route, data)
  }
  manager.prototype.createService = function (data) {
    return API.post('service', data)
  }
  manager.prototype.update = function (id, data) {
    return API.put(`${route}${id}`, data)
  }
  manager.prototype.remove = function (id) {
    return API.delete(`${route}${id}`)
  }
  manager.prototype.getList = function () {
    return API.get(`${route}list`)
  }
  manager.prototype.formatPermission = function (permission) {
    switch (permission) {
      case 0:
        return '最高權限'
        break
      case 1:
        return '管理者'
        break
      case 2:
        return '派車主管'
        break
      case 3:
        return '行政人員'
        break
      case 4:
        return '派車員'
        break
      default:
        return ''
    }
  }

  return manager
})()
export default Manager



// WEBPACK FOOTER //
// ./src/assets/js/libs/Manager.js